module.exports = __webpack_public_path__ + "media/responsive/contact-fbd837e7.jpg";